import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { MsalInterceptor } from '@azure/msal-angular';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { errorInterceptor } from './http/error.interceptor';
import { versionInterceptor } from './http/version.interceptor';
import { provideMatConfig } from './material/material.config';
import { AppRouteReuseStrategy } from './routing/app-route-reuse-strategy';
import { provideMsal } from './utils/msal.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    { provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy },
    provideMsal(),
    provideToastr(),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([
      versionInterceptor,
      errorInterceptor
    ])),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    provideMatConfig()
  ]
};
